export function resolveTargetName(data: Record<string, any> | null | undefined): string {
  if (!data) return '';
  if (data.businessName) return data.businessName;
  const parts = [data.firstName, data.lastName].filter(
    (p): p is string => typeof p === 'string' && p.trim() !== '',
  );
  return parts.join(' ');
}
